module.exports = __webpack_public_path__ + "img/Weapon_09.b7fbe1a6.png";